/**
 * ProductCategory DTO - nested category payload returned by the API.
 */
export class ProductCategoryDto {
  constructor(data = {}) {
    this.id = data.id || null;
    this.code = data.code || '';
    this.name = data.name || '';
    this.subcategoryName = data.subcategoryName ?? null;
    this.subcategoryCode = data.subcategoryCode ?? null;
    this.vatRate = data.vatRate ?? null;
    this.isActive = data.isActive !== undefined ? data.isActive : true;
  }

  static fromJSON(json) {
    if (!json) {
      return null;
    }

    return new ProductCategoryDto({
      id: json.id,
      code: json.code,
      name: json.name,
      subcategoryName: json.subcategoryName,
      subcategoryCode: json.subcategoryCode,
      vatRate: json.vatRate,
      isActive: json.isActive,
    });
  }

  toJSON() {
    return {
      id: this.id,
      code: this.code,
      name: this.name,
      subcategoryName: this.subcategoryName,
      subcategoryCode: this.subcategoryCode,
      vatRate: this.vatRate,
      isActive: this.isActive,
    };
  }
}